<template>
    <div class="com-container1">
        <div class="table-container1">
            <table>
                
                <!-- 表头 -->
                <!-- <div> -->
                    <thead>
                        <tr>
                            <th>地址</th>
                            <th>警告事件</th>
                            <th>时间</th>
                        </tr>
                    </thead>
                <!-- </div> -->
            </table>

        </div>
        <div class="table-container">
            <table>
                <!-- 表格数据 -->
                <!-- <div> -->
                    <tbody>
                        <tr v-for="(item, index) in tableData" :key="index">
                            <td>{{ item.address }}</td>
                            <td>{{ item.event }}</td>
                            <td>{{ item.time }}</td>
                        </tr>
                    </tbody>
                <!-- </div> -->
            </table>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            // 表格数据
            tableData: [
                { address: "病房楼出水口", event: "出水温度51℃,温度过高", time: "2025-3-01 10:20" },
                { address: "病房楼出水口", event: "出水温度53℃,温度过高", time: "2025-3-04 10:31" },
                { address: "病房楼出水口", event: "出水温度51℃,温度过高", time: "2025-3-06 10:40" },
                { address: "病房楼出水口", event: "出水温度52℃,温度过高", time: "2025-3-12 10:50" },
                { address: "病房楼出水口", event: "出水温度54℃,温度过高", time: "2025-3-13 10:23" },
            ]
        };
    }
};
</script>

<style>
/* 全局样式 */
.com-container1 {
    margin: 0;
    padding: 0;
    height: 100%;
    width: 100%;
    background: linear-gradient(135deg, #0f0c29, #302b63, #24243e);
    /* 深蓝色渐变背景 */
    color: #fff;
    font-family: 'Orbitron', sans-serif;
    /* 科技感字体 */
}

/* #app {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 10vh;
    width: 100vw;
} */

/* 表格容器 */
.table-container1 {
    width: 95%;
    /* 宽度自适应 */
    max-width: 1900px;
    /* 最大宽度 */
    height: 10vh;
    /* 高度自适应 */
    /* overflow: auto; */
    /* 如果内容超出屏幕，显示滚动条 */
    background: rgba(0, 0, 0, 0.6);
    /* 半透明黑色背景 */
    border-radius: 15px 15px 0 0 ;
    /* 圆角 */
    border: 2px solid rgba(255, 255, 255, 0.1);
    /* 边框 */
    box-shadow: 0 0 20px rgba(0, 255, 255, 0.5);
    /* 发光效果 */
    backdrop-filter: blur(10px);
    /* 背景模糊 */
    padding: 20px;
    margin-left: 10px;
    margin-top: 5px;
    box-sizing: border-box;
}/* 表格容器 */
.table-container {
    width: 95%;
    /* 宽度自适应 */
    max-width: 1900px;
    /* 最大宽度 */
    height: 30vh;
    /* 高度自适应 */
    overflow: auto;
    /* 如果内容超出屏幕，显示滚动条 */
    background: rgba(0, 0, 0, 0.6);
    /* 半透明黑色背景 */
    border-radius: 0 0 15px 15px;
    /* 圆角 */
    border: 2px solid rgba(255, 255, 255, 0.1);
    /* 边框 */
    box-shadow: 0 0 20px rgba(0, 255, 255, 0.5);
    /* 发光效果 */
    backdrop-filter: blur(10px);
    /* 背景模糊 */
    padding: 20px;
    margin-left: 10px;
    box-sizing: border-box;
}

/* 表格样式 */
table {
    width: 100%;
    border-collapse: collapse;
}

th,
td {
    padding: 15px;
    text-align: left;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    /* 浅色边框 */
}

th {
    background: linear-gradient(135deg, #00d2ff, #3a7bd5);
    /* 表头渐变背景 */
    color: #fff;
    font-weight: bold;
    text-transform: uppercase;
    /* 字母大写 */
    position: sticky;
    top: 0;
    /* 表头固定在顶部 */
    z-index: 1;
}

/* 表格行悬浮效果 */
tbody tr:hover {
    background: rgba(255, 255, 255, 0.1);
    /* 悬浮时背景变亮 */
    transform: scale(1.02);
    /* 悬浮时放大 */
    transition: all 0.3s ease;
}

/* 滚动条样式 */
.table-container::-webkit-scrollbar {
    width: 8px;
}

.table-container::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 10px;
}

.table-container::-webkit-scrollbar-thumb {
    background: linear-gradient(135deg, #00d2ff, #3a7bd5);
    border-radius: 10px;
}

/* 字体和表格自适应 */
@media (max-width: 768px) {

    th,
    td {
        padding: 12px;
        font-size: 14px;
    }
}

@media (max-width: 480px) {

    th,
    td {
        padding: 10px;
        font-size: 12px;
    }
}
</style>